var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageUsersIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5069_95315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 16.875C14.0711 16.875 15.75 15.1961 15.75 13.125C15.75 11.0539 14.0711 9.375 12 9.375C9.92893 9.375 8.25 11.0539 8.25 13.125C8.25 15.1961 9.92893 16.875 12 16.875Z",
    stroke: "#8879A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.375 10.875C19.2485 10.8735 20.1103 11.0762 20.8916 11.4669C21.6729 11.8575 22.3521 12.4253 22.875 13.125",
    stroke: "#8879A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.125 13.125C1.64794 12.4253 2.32714 11.8575 3.10843 11.4669C3.88972 11.0762 4.75149 10.8735 5.625 10.875",
    stroke: "#8879A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59961 20.2496C7.09351 19.2381 7.86156 18.3856 8.81628 17.7894C9.77099 17.1931 10.874 16.877 11.9996 16.877C13.1252 16.877 14.2282 17.1931 15.1829 17.7894C16.1377 18.3856 16.9057 19.2381 17.3996 20.2496",
    stroke: "#8879A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62463 10.875C5.05523 10.8756 4.49742 10.7141 4.01639 10.4094C3.53536 10.1048 3.15096 9.6695 2.90811 9.15449C2.66527 8.63947 2.574 8.06598 2.64498 7.50102C2.71597 6.93607 2.94626 6.40298 3.30896 5.96404C3.67166 5.52511 4.15178 5.19845 4.69323 5.02225C5.23468 4.84605 5.81509 4.82758 6.36665 4.96899C6.91821 5.11041 7.41813 5.40587 7.80801 5.82085C8.19789 6.23583 8.46161 6.7532 8.56838 7.3125",
    stroke: "#8879A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4316 7.3125C15.5384 6.7532 15.8021 6.23583 16.192 5.82085C16.5819 5.40587 17.0818 5.11041 17.6334 4.96899C18.1849 4.82758 18.7653 4.84605 19.3068 5.02225C19.8482 5.19845 20.3284 5.52511 20.6911 5.96404C21.0538 6.40298 21.2841 6.93607 21.355 7.50102C21.426 8.06598 21.3347 8.63947 21.0919 9.15449C20.8491 9.6695 20.4647 10.1048 19.9836 10.4094C19.5026 10.7141 18.9448 10.8756 18.3754 10.875",
    stroke: "#8879A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5069_95315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageUsersIcon);
export default __webpack_public_path__ + "static/media/manage_users_icon.c95276b97c7a4af23b1458e9ce1b14c0.svg";
export { ForwardRef as ReactComponent };